import { Badge } from '@mui/material';
import {
  useRecordContext,
  DateFieldProps,
  TextField,
} from 'react-admin';

import { YYYYMMDDtoDate } from 'shared/utils/date';

function AcquisitionsField({ ...props }: DateFieldProps) {
  const record = useRecordContext();
  const dateTimes: string[] = record?.[props.source]
  if (!dateTimes?.length) return null;

  const dates = dateTimes
    .map((dateTime) => dateTime?.split('-')[1])
    .filter((value): value is string => Boolean(value))
    .map(YYYYMMDDtoDate)
    .filter(
      (date): date is Date =>
        date instanceof Date && !Number.isNaN(date.getTime()),
    )
    .sort((a, b) => a.getTime() - b.getTime());

  const dateStrings = dates.map((date) =>
    date.toLocaleString(props.locales, props.options),
  );

  const dateString = dateStrings.at(-1);

  // The API did not provide any usable dates.
  if (!dateString) return null;

  if (dateStrings.length === 1) {
    return (
      <TextField
        {...props}
        source="text"
        record={{ ...record, text: dateString }}
      />
    );
  }

  return (
    <Badge
      badgeContent={`+${dateStrings.length - 1}`}
      sx={{ '& .MuiBadge-badge': { marginRight: '-0.7em' } }}
    >
      <TextField
        {...props}
        source="text"
        record={{ ...record, text: dateString }}
        title={dateStrings.join(' <-> ')}
      />
    </Badge>
  );
}

export default AcquisitionsField;